var render = function render(){var _vm=this,_c=_vm._self._c;return _c('master-main',{attrs:{"addProperties":{ eventType: 1, routeToCreate: _vm.getModuleRoute },"dataBadges":[
    {
      columnLabel: _vm.$t('common_words.associated_companies2'),
      data: 'businesses',
      property: 'name',
      minWidth: 160,
    },
    {
      columnLabel: _vm.$t('common_words.farm'),
      data: 'farms',
      property: 'name',
      minWidth: 160,
    },
  ],"route":_vm.getModuleRoute,"tableProperties":_vm.tableProperties,"showExportTables":false},on:{"refresh":_vm.refresh,"showHideLoading":_vm.showHideLoading,"showNotification":_vm.notifyVue}})
}
var staticRenderFns = []

export { render, staticRenderFns }